import * as z from "zod";

export const SensorNameEnum = {
    RAT_CAMERA_PROB: "RAT_CAMERA_PROB",
    RAT_CAMERA_TIME: "RAT_CAMERA_TIME",
    RAT_CAMERA_NUMBER: "RAT_CAMERA_NUMBER",
    RAT_TRAP_TIME: "RAT_TRAP_TIME",
    RAT_TRAP_NUMBER: "RAT_TRAP_NUMBER",
    BAT_0: "BAT_0",
    WND_ERR: "WND_ERR",
    VEH_ERR: "VEH_ERR",
    WLDR_ERR: "WLDR_ERR",
    DPLY_SLP: "DPLY_SLP",
    DPLY_SREF: "DPLY_SREF",
    DPLY_SPD: "DPLY_SPD",
    GEO_LEN: "GEO_LEN",
    GEO_POS: "GEO_POS",
    WLDR_OVER: "WLDR_OVER",
    WLDR_PRES: "WLDR_PRES",
    WDGE_TRAL: "WDGE_TRAL",
    WLDR_VEL_X: "WLDR_VEL_X",
    LA_0_BLE: "LA_0_BLE",
    UV_0_BLE: "UV_0_BLE",
    HR_0_BLE: "HR_0_BLE",
    TA_0_BLE: "TA_0_BLE",
    RGB_N3: "RGB_N3",
    RGB_N2: "RGB_N2",
    RGB_N1: "RGB_N1",
    SRS_4_LONG: "SRS_4_LONG",
    SRS_4_LAT: "SRS_4_LAT",
    SRS_4_PRI: "SRS_4_PRI",
    SRS_4_NDVI: "SRS_4_NDVI",
    SRS_3_LAT: "SRS_3_LAT",
    SRS_3_PRI: "SRS_3_PRI",
    SRS_3_NDVI: "SRS_3_NDVI",
    SRS_2_LONG: "SRS_2_LONG",
    SRS_2_LAT: "SRS_2_LAT",
    SRS_2_PRI: "SRS_2_PRI",
    SRS_2_NDVI: "SRS_2_NDVI",
    SRS_1_LONG: "SRS_1_LONG",
    SRS_1_LAT: "SRS_1_LAT",
    SRS_1_PRI: "SRS_1_PRI",
    SRS_1_NDVI: "SRS_1_NDVI",
    RGB_LONG: "RGB_LONG",
    RGB_LAT: "RGB_LAT",
    RGB_R3: "RGB_R3",
    RGB_R2: "RGB_R2",
    RGB_R1: "RGB_R1",
    RGB_V3: "RGB_V3",
    RGB_V2: "RGB_V2",
    RGB_V1: "RGB_V1",
    RAT_0: "RAT_0",
    ORP_0: "ORP_0",
    TEMP_0: "TEMP_0",
    PRESSURE: "PRESSURE",
    WIND_SPEED: "WIND_SPEED",
    WIND_GUST: "WIND_GUST",
    WIND_DIRECTION: "WIND_DIRECTION",
    HPR_0_BLE: "HPR_0_BLE",
    STV_J_BLE: "STV_J_BLE",
    STV_O_BLE: "STV_O_BLE",
    STV_H_BLE: "STV_H_BLE",
    STV_F_BLE: "STV_F_BLE",
    C6_Acum: "C6_Acum",
    C5_Acum: "C5_Acum",
    C4_Acum: "C4_Acum",
    C3_Acum: "C3_Acum",
    C2_Acum: "C2_Acum",
    C1_Acum: "C1_Acum",
    CA6: "CA6",
    CA5: "CA5",
    BAT_BLE: "BAT_BLE",
    BOX_1: "BOX_1",
    EA2_MA: "EA2_MA",
    EA1_MA: "EA1_MA",
    RS: "RS",
    VS4: "VS4",
    VS3: "VS3",
    VS2: "VS2",
    VS1: "VS1",
    CA4: "CA4",
    CA3: "CA3",
    CA2: "CA2",
    CA1: "CA1",
    ISUI_ALERT: "ISUI_ALERT",
    BAT_STR: "BAT_STR",
    HPR_1: "HPR_1",
    CAU_0: "CAU_0",
    DEF_HIDRICO: "DEF_HIDRICO",
    TA_420: "TA_420",
    CE_GRAV: "CE_GRAV",
    PLU_1: "PLU_1",
    BOX_0: "BOX_0",
    WGT_0: "WGT_0",
    CH_D123: "CH_D123",
    CH_D122: "CH_D122",
    CH_D121: "CH_D121",
    CH_D120: "CH_D120",
    CH_D113: "CH_D113",
    CH_D112: "CH_D112",
    CH_D111: "CH_D111",
    CH_D110: "CH_D110",
    CH_D103: "CH_D103",
    CH_D102: "CH_D102",
    CH_D101: "CH_D101",
    CH_D100: "CH_D100",
    CH_Y037: "CH_Y037",
    CH_Y036: "CH_Y036",
    CH_Y035: "CH_Y035",
    CH_Y034: "CH_Y034",
    CH_Y033: "CH_Y033",
    CH_Y032: "CH_Y032",
    CH_Y031: "CH_Y031",
    CH_Y030: "CH_Y030",
    CH_Y027: "CH_Y027",
    CH_Y026: "CH_Y026",
    CH_Y025: "CH_Y025",
    CH_Y024: "CH_Y024",
    CH_Y023: "CH_Y023",
    CH_Y022: "CH_Y022",
    CH_Y021: "CH_Y021",
    CH_Y020: "CH_Y020",
    CH_Y017: "CH_Y017",
    CH_Y016: "CH_Y016",
    CH_Y015: "CH_Y015",
    CH_Y014: "CH_Y014",
    CH_Y013: "CH_Y013",
    CH_Y012: "CH_Y012",
    CH_Y011: "CH_Y011",
    CH_Y010: "CH_Y010",
    CH_Y007: "CH_Y007",
    CH_Y006: "CH_Y006",
    CH_Y005: "CH_Y005",
    CH_Y004: "CH_Y004",
    CH_Y003: "CH_Y003",
    CH_Y002: "CH_Y002",
    CH_Y001: "CH_Y001",
    CH_Y000: "CH_Y000",
    CH_X037: "CH_X037",
    CH_X036: "CH_X036",
    CH_X035: "CH_X035",
    CH_X034: "CH_X034",
    CH_X033: "CH_X033",
    CH_X032: "CH_X032",
    CH_X031: "CH_X031",
    CH_X030: "CH_X030",
    CH_X027: "CH_X027",
    CH_X026: "CH_X026",
    CH_X025: "CH_X025",
    CH_X024: "CH_X024",
    CH_X023: "CH_X023",
    CH_X022: "CH_X022",
    CH_X021: "CH_X021",
    CH_X020: "CH_X020",
    CH_X017: "CH_X017",
    CH_X016: "CH_X016",
    CH_X015: "CH_X015",
    CH_X014: "CH_X014",
    CH_X013: "CH_X013",
    CH_X012: "CH_X012",
    CH_X011: "CH_X011",
    CH_X010: "CH_X010",
    CH_X007: "CH_X007",
    CH_X006: "CH_X006",
    CH_X005: "CH_X005",
    CH_X004: "CH_X004",
    CH_X003: "CH_X003",
    CH_X002: "CH_X002",
    CH_X001: "CH_X001",
    CH_X000: "CH_X000",
    CH_COMM_ERR: "CH_COMM_ERR",
    STV_N_1: "STV_N_1",
    STV_L_1: "STV_L_1",
    STV_N: "STV_N",
    STV_L: "STV_L",
    NVL_0: "NVL_0",
    PR_0: "PR_0",
    CAP_0: "CAP_0",
    TIR_0_AMB: "TIR_0_AMB",
    C_L1_AN: "C_L1_AN",
    ERR_DLMS: "ERR_DLMS",
    PF: "PF",
    PRM_L1: "PRM_L1",
    PRP_L1: "PRP_L1",
    PAM_L1: "PAM_L1",
    PAP_L1: "PAP_L1",
    FR: "FR",
    C_L1: "C_L1",
    V_L1: "V_L1",
    CO2_1: "CO2_1",
    RT_PYR_GLOBAL_0: "RT_PYR_GLOBAL_0",
    RT_DPV: "RT_DPV",
    RT_STV_Q_1: "RT_STV_Q_1",
    RT_STV_O_1: "RT_STV_O_1",
    RT_STV_J_1: "RT_STV_J_1",
    RT_STV_H_1: "RT_STV_H_1",
    RT_STV_F_1: "RT_STV_F_1",
    RT_STV_Q: "RT_STV_Q",
    RT_STV_O: "RT_STV_O",
    RT_STV_J: "RT_STV_J",
    RT_STV_H: "RT_STV_H",
    RT_STV_F: "RT_STV_F",
    RT_NK_1: "RT_NK_1",
    RT_NN_1: "RT_NN_1",
    RT_NK_0: "RT_NK_0",
    RT_NN_0: "RT_NN_0",
    RT_PYR_0: "RT_PYR_0",
    RT_CO2_0: "RT_CO2_0",
    RT_DWP_0: "RT_DWP_0",
    RT_HR_0: "RT_HR_0",
    RT_TA_0: "RT_TA_0",
    CNT_CAU_INFOCULTIVO: "CNT_CAU_INFOCULTIVO",
    CNT_CAU_ACUM: "CNT_CAU_ACUM",
    CNT_CAU_HIST_1: "CNT_CAU_HIST_1",
    CNT_CAU_HIST: "CNT_CAU_HIST",
    CNT_CAU_1: "CNT_CAU_1",
    LD_PH_1: "LD_PH_1",
    LD_PH_0: "LD_PH_0",
    LD_REDOX_1: "LD_REDOX_1",
    LD_REDOX_0: "LD_REDOX_0",
    CNT_PLU_BT: "CNT_PLU_BT",
    CNT_CAU_BT: "CNT_CAU_BT",
    V4_TR: "V4_TR",
    V4_ON: "V4_ON",
    V3_TR: "V3_TR",
    V3_ON: "V3_ON",
    V2_TR: "V2_TR",
    V2_ON: "V2_ON",
    V1_TR: "V1_TR",
    V1_ON: "V1_ON",
    FRUIT_WEIGHT: "FRUIT_WEIGHT",
    CNT_PLU: "CNT_PLU",
    CNT_CAU: "CNT_CAU",
    VP4_ATM_1: "VP4_ATM_1",
    VP4_ATM: "VP4_ATM",
    VP4_HUM_1: "VP4_HUM_1",
    VP4_HUM: "VP4_HUM",
    VP4_TEM_1: "VP4_TEM_1",
    VP4_TEM: "VP4_TEM",
    VP4_VAP_1: "VP4_VAP_1",
    VP4_VAP: "VP4_VAP",
    "5TE_CPW_2": "5TE_CPW_2",
    "5TE_HUM_2": "5TE_HUM_2",
    "5TE_CON_2": "5TE_CON_2",
    "5TE_TEM_2": "5TE_TEM_2",
    "5TE_DIE_2": "5TE_DIE_2",
    "5TE_CPW_1": "5TE_CPW_1",
    "5TE_HUM_1": "5TE_HUM_1",
    "5TE_CON_1": "5TE_CON_1",
    "5TE_TEM_1": "5TE_TEM_1",
    "5TE_DIE_1": "5TE_DIE_1",
    ES2_CON_1: "ES2_CON_1",
    ES2_TEM_1: "ES2_TEM_1",
    ALARMA_DIST: "ALARMA_DIST",
    TEMP_DIST: "TEMP_DIST",
    I2CST: "I2CST",
    DIST_0: "DIST_0",
    "5TE_CPW": "5TE_CPW",
    GS3_CPW: "GS3_CPW",
    BARON_TAG_OK: "BARON_TAG_OK",
    BARON_TAG_2: "BARON_TAG_2",
    BARON_TAG_1: "BARON_TAG_1",
    ALTITUDE: "ALTITUDE",
    ANGLE: "ANGLE",
    MVEL_0: "MVEL_0",
    p_v_s: "p_v_s",
    p_v_eu: "p_v_eu",
    p_v_co: "p_v_co",
    p_t_r_s: "p_t_r_s",
    p_t_r_eu: "p_t_r_eu",
    p_t_r_eu_c: "p_t_r_eu_c",
    p_t_hi_eu: "p_t_hi_eu",
    p_t_r_c: "p_t_r_c",
    p_t_r_co: "p_t_r_co",
    p_t_cos: "p_t_cos",
    p_t_eu: "p_t_eu",
    p_t: "p_t",
    p_t_co: "p_t_co",
    p_hu_co: "p_hu_co",
    p_dpv: "p_dpv",
    p_v_hi: "p_v_hi",
    HPR_0: "HPR_0",
    "5TE_HUM": "5TE_HUM",
    "5TE_TEM": "5TE_TEM",
    "5TE_CON": "5TE_CON",
    "5TE_DIE": "5TE_DIE",
    ES2_TEM: "ES2_TEM",
    ES2_CON: "ES2_CON",
    GS3_HUM: "GS3_HUM",
    GS3_CON: "GS3_CON",
    GS3_TEM: "GS3_TEM",
    GS3_DIE: "GS3_DIE",
    A5: "A5",
    A4: "A4",
    A3: "A3",
    A2: "A2",
    A1: "A1",
    A0: "A0",
    OX_PQ: "OX_PQ",
    OX_P: "OX_P",
    OX_OSQ: "OX_OSQ",
    OX_OS: "OX_OS",
    OX_TQ: "OX_TQ",
    OX_T: "OX_T",
    OX_OCQ: "OX_OCQ",
    OX_OC: "OX_OC",
    TRA_CUM_TOTAL: "TRA_CUM_TOTAL",
    TRA_REA: "TRA_REA",
    TRA_CUM: "TRA_CUM",
    TRA_ERR: "TRA_ERR",
    TRA_CON: "TRA_CON",
    TRA_ACT: "TRA_ACT",
    TRA_TIP: "TRA_TIP",
    TRA_SIG: "TRA_SIG",
    TIR_0: "TIR_0",
    STV_Q_1: "STV_Q_1",
    PYR_3: "PYR_3",
    FORMATTED_ADDRESS: "FORMATTED_ADDRESS",
    ZIN_2: "ZIN_2",
    ZIN_1: "ZIN_1",
    ZIN_0: "ZIN_0",
    SUL_2: "SUL_2",
    SUL_1: "SUL_1",
    SUL_0: "SUL_0",
    SOD_2: "SOD_2",
    SOD_1: "SOD_1",
    SOD_0: "SOD_0",
    POT_2: "POT_2",
    POT_1: "POT_1",
    POT_0: "POT_0",
    PH_2: "PH_2",
    PH_1: "PH_1",
    PH_0: "PH_0",
    NIT_AA3_SEG_2: "NIT_AA3_SEG_2",
    NIT_AA3_SEG_1: "NIT_AA3_SEG_1",
    NIT_AA3_SEG_0: "NIT_AA3_SEG_0",
    MANG_2: "MANG_2",
    MANG_1: "MANG_1",
    MANG_0: "MANG_0",
    MAG_2: "MAG_2",
    MAG_1: "MAG_1",
    MAG_0: "MAG_0",
    HIE_2: "HIE_2",
    HIE_1: "HIE_1",
    HIE_0: "HIE_0",
    FOS_2: "FOS_2",
    FOS_1: "FOS_1",
    FOS_0: "FOS_0",
    CEA_2: "CEA_2",
    CEA_1: "CEA_1",
    CEA_0: "CEA_0",
    COB_2: "COB_2",
    COB_1: "COB_1",
    COB_0: "COB_0",
    CLO_AA3_2: "CLO_AA3_2",
    CLO_AA3_1: "CLO_AA3_1",
    CLO_AA3_0: "CLO_AA3_0",
    CAL_2: "CAL_2",
    CAL_1: "CAL_1",
    CAL_0: "CAL_0",
    BOR_2: "BOR_2",
    BOR_1: "BOR_1",
    Amon_AA3_2: "Amon_AA3_2",
    Amon_AA3_1: "Amon_AA3_1",
    BOR_0: "BOR_0",
    Amon_AA3_0: "Amon_AA3_0",
    HST: "HST",
    NN_1: "NN_1",
    NN_0: "NN_0",
    NK_1: "NK_1",
    NK_0: "NK_0",
    VIN: "VIN",
    PEIN: "PEIN",
    ANG31: "ANG31",
    ANG23: "ANG23",
    ANG12: "ANG12",
    FRC: "FRC",
    FPT: "FPT",
    FP3: "FP3",
    FP2: "FP2",
    FP1: "FP1",
    PAPT: "PAPT",
    PAP3: "PAP3",
    PAP2: "PAP2",
    PAP1: "PAP1",
    PRET: "PRET",
    PRE3: "PRE3",
    PRE2: "PRE2",
    PRE1: "PRE1",
    PACT: "PACT",
    PAC3: "PAC3",
    PAC2: "PAC2",
    PAC1: "PAC1",
    CL3: "CL3",
    CL2: "CL2",
    CL1: "CL1",
    VL31: "VL31",
    VL23: "VL23",
    VL12: "VL12",
    VL3: "VL3",
    VL2: "VL2",
    VL1: "VL1",
    "ICR_ARE02.FCOM": "ICR_ARE02.FCOM",
    "ICR_ARE01.FCOM": "ICR_ARE01.FCOM",
    "ICR_DEP02.CMIN": "ICR_DEP02.CMIN",
    "ICR_DEP02.CMAX": "ICR_DEP02.CMAX",
    "ICR_DEP01.CMIN": "ICR_DEP01.CMIN",
    "ICR_DEP01.CMAX": "ICR_DEP01.CMAX",
    "ICR_ARE02.POTACT": "ICR_ARE02.POTACT",
    "ICR_ARE02.TEN12": "ICR_ARE02.TEN12",
    "ICR_ARE01.POTACT": "ICR_ARE01.POTACT",
    "ICR_ARE01.TEN12": "ICR_ARE01.TEN12",
    "ICR_DEP02.AMIN": "ICR_DEP02.AMIN",
    "ICR_DEP02.LSMIN": "ICR_DEP02.LSMIN",
    "ICR_DEP02.AMAX": "ICR_DEP02.AMAX",
    "ICR_DEP01.AMIN": "ICR_DEP01.AMIN",
    "ICR_DEP01.LSMIN": "ICR_DEP01.LSMIN",
    "ICR_DEP01.AMAX": "ICR_DEP01.AMAX",
    "ICR_PL01.LSIG": "ICR_PL01.LSIG",
    "ICR_PL01.LBAT": "ICR_PL01.LBAT",
    "ICR_FT01.VAL": "ICR_FT01.VAL",
    BAR_0: "BAR_0",
    "ICR_VLV03.FCC": "ICR_VLV03.FCC",
    "ICR_VLV03.FCA": "ICR_VLV03.FCA",
    "ICR_VLV02.FCC": "ICR_VLV02.FCC",
    "ICR_VLV02.FCA": "ICR_VLV02.FCA",
    "ICR_VLV01.FCC": "ICR_VLV01.FCC",
    "ICR_VLV01.FCA": "ICR_VLV01.FCA",
    "ICR_VLV04.STA": "ICR_VLV04.STA",
    "ICR_VLV03.STA": "ICR_VLV03.STA",
    "ICR_VLV02.STA": "ICR_VLV02.STA",
    "ICR_VLV01.STA": "ICR_VLV01.STA",
    "ICR_BOM05.CM": "ICR_BOM05.CM",
    "ICR_BOM04.CM": "ICR_BOM04.CM",
    "ICR_BOM03.CM": "ICR_BOM03.CM",
    "ICR_BOM02.CM": "ICR_BOM02.CM",
    "ICR_BOM01.CM": "ICR_BOM01.CM",
    "ICR_VLV03.EPOS": "ICR_VLV03.EPOS",
    "ICR_VLV02.EPOS": "ICR_VLV02.EPOS",
    "ICR_VLV01.EPOS": "ICR_VLV01.EPOS",
    "ICR_TOT13.VAL": "ICR_TOT13.VAL",
    "ICR_TOT13.TOT": "ICR_TOT13.TOT",
    "ICR_TOT13.MINNOCT": "ICR_TOT13.MINNOCT",
    "ICR_TOT13.AYERTOT": "ICR_TOT13.AYERTOT",
    "ICR_TOT12.VAL": "ICR_TOT12.VAL",
    "ICR_TOT12.TOT": "ICR_TOT12.TOT",
    "ICR_TOT12.MINNOCT": "ICR_TOT12.MINNOCT",
    "ICR_TOT12.AYERTOT": "ICR_TOT12.AYERTOT",
    "ICR_TOT11.VAL": "ICR_TOT11.VAL",
    "ICR_TOT11.TOT": "ICR_TOT11.TOT",
    "ICR_TOT11.MINNOCT": "ICR_TOT11.MINNOCT",
    "ICR_TOT11.AYERTOT": "ICR_TOT11.AYERTOT",
    "ICR_TOT10.VAL": "ICR_TOT10.VAL",
    "ICR_TOT10.TOT": "ICR_TOT10.TOT",
    "ICR_TOT10.MINNOCT": "ICR_TOT10.MINNOCT",
    "ICR_TOT10.AYERTOT": "ICR_TOT10.AYERTOT",
    "ICR_TOT09.VAL": "ICR_TOT09.VAL",
    "ICR_TOT09.TOT": "ICR_TOT09.TOT",
    "ICR_TOT09.MINNOCT": "ICR_TOT09.MINNOCT",
    "ICR_TOT09.AYERTOT": "ICR_TOT09.AYERTOT",
    "ICR_TOT08.VAL": "ICR_TOT08.VAL",
    "ICR_TOT08.TOT": "ICR_TOT08.TOT",
    "ICR_TOT08.MINNOCT": "ICR_TOT08.MINNOCT",
    "ICR_TOT08.AYERTOT": "ICR_TOT08.AYERTOT",
    "ICR_TOT07.VAL": "ICR_TOT07.VAL",
    "ICR_TOT07.TOT": "ICR_TOT07.TOT",
    "ICR_TOT07.MINNOCT": "ICR_TOT07.MINNOCT",
    "ICR_TOT07.AYERTOT": "ICR_TOT07.AYERTOT",
    "ICR_TOT06.VAL": "ICR_TOT06.VAL",
    "ICR_TOT06.TOT": "ICR_TOT06.TOT",
    "ICR_TOT06.MINNOCT": "ICR_TOT06.MINNOCT",
    "ICR_TOT06.AYERTOT": "ICR_TOT06.AYERTOT",
    "ICR_TOT05.VAL": "ICR_TOT05.VAL",
    "ICR_TOT05.TOT": "ICR_TOT05.TOT",
    "ICR_TOT05.MINNOCT": "ICR_TOT05.MINNOCT",
    "ICR_TOT05.AYERTOT": "ICR_TOT05.AYERTOT",
    "ICR_TOT04.VAL": "ICR_TOT04.VAL",
    "ICR_TOT04.TOT": "ICR_TOT04.TOT",
    "ICR_TOT04.MINNOCT": "ICR_TOT04.MINNOCT",
    "ICR_TOT04.AYERTOT": "ICR_TOT04.AYERTOT",
    "ICR_TOT04.RIEGOTOT": "ICR_TOT04.RIEGOTOT",
    "ICR_TOT03.VAL": "ICR_TOT03.VAL",
    "ICR_TOT03.TOT": "ICR_TOT03.TOT",
    "ICR_TOT03.MINNOCT": "ICR_TOT03.MINNOCT",
    "ICR_TOT03.AYERTOT": "ICR_TOT03.AYERTOT",
    "ICR_TOT03.RIEGOTOT": "ICR_TOT03.RIEGOTOT",
    "ICR_TOT02.VAL": "ICR_TOT02.VAL",
    "ICR_TOT02.TOT": "ICR_TOT02.TOT",
    "ICR_TOT02.MINNOCT": "ICR_TOT02.MINNOCT",
    "ICR_TOT02.AYERTOT": "ICR_TOT02.AYERTOT",
    "ICR_TOT02.RIEGOTOT": "ICR_TOT02.RIEGOTOT",
    "ICR_TOT01.VAL": "ICR_TOT01.VAL",
    "ICR_TOT01.TOT": "ICR_TOT01.TOT",
    "ICR_TOT01.MINNOCT": "ICR_TOT01.MINNOCT",
    "ICR_TOT01.AYERTOT": "ICR_TOT01.AYERTOT",
    "ICR_TOT01.RIEGOTOT": "ICR_TOT01.RIEGOTOT",
    "ICR_PT05.VAL": "ICR_PT05.VAL",
    "ICR_PT04.VAL": "ICR_PT04.VAL",
    "ICR_PT03.VAL": "ICR_PT03.VAL",
    "ICR_PT02.VAL": "ICR_PT02.VAL",
    "ICR_PT01.VAL": "ICR_PT01.VAL",
    "ICR_DEP02.VAL": "ICR_DEP02.VAL",
    "ICR_DEP01.VAL": "ICR_DEP01.VAL",
    "ICR_BOM05.TOTM": "ICR_BOM05.TOTM",
    "ICR_BOM05.TOTH": "ICR_BOM05.TOTH",
    "ICR_BOM05.AYERM": "ICR_BOM05.AYERM",
    "ICR_BOM05.AYERH": "ICR_BOM05.AYERH",
    "ICR_BOM04.TOTM": "ICR_BOM04.TOTM",
    "ICR_BOM04.TOTH": "ICR_BOM04.TOTH",
    "ICR_BOM04.AYERM": "ICR_BOM04.AYERM",
    "ICR_BOM04.AYERH": "ICR_BOM04.AYERH",
    "ICR_BOM03.TOTM": "ICR_BOM03.TOTM",
    "ICR_BOM03.TOTH": "ICR_BOM03.TOTH",
    "ICR_BOM03.AYERM": "ICR_BOM03.AYERM",
    "ICR_BOM03.AYERH": "ICR_BOM03.AYERH",
    "ICR_BOM02.TOTM": "ICR_BOM02.TOTM",
    "ICR_BOM02.TOTH": "ICR_BOM02.TOTH",
    "ICR_BOM02.AYERM": "ICR_BOM02.AYERM",
    "ICR_BOM02.AYERH": "ICR_BOM02.AYERH",
    "ICR_BOM01.TOTM": "ICR_BOM01.TOTM",
    "ICR_BOM01.TOTH": "ICR_BOM01.TOTH",
    "ICR_BOM01.AYERM": "ICR_BOM01.AYERM",
    "ICR_BOM01.AYERH": "ICR_BOM01.AYERH",
    "ICR_ARE02.POTAPA": "ICR_ARE02.POTAPA",
    "ICR_ARE02.INT3": "ICR_ARE02.INT3",
    "ICR_ARE02.INT2": "ICR_ARE02.INT2",
    "ICR_ARE02.INT1": "ICR_ARE02.INT1",
    "ICR_ARE02.FREQ": "ICR_ARE02.FREQ",
    "ICR_ARE02.FACTORPOT": "ICR_ARE02.FACTORPOT",
    "ICR_ARE02.ENERREA": "ICR_ARE02.ENERREA",
    "ICR_ARE02.ENERAPA": "ICR_ARE02.ENERAPA",
    "ICR_ARE02.ENERACT": "ICR_ARE02.ENERACT",
    "ICR_ARE01.POTAPA": "ICR_ARE01.POTAPA",
    "ICR_ARE01.INT3": "ICR_ARE01.INT3",
    "ICR_ARE01.INT2": "ICR_ARE01.INT2",
    "ICR_ARE01.INT1": "ICR_ARE01.INT1",
    "ICR_ARE01.FREQ": "ICR_ARE01.FREQ",
    "ICR_ARE01.FACTORPOT": "ICR_ARE01.FACTORPOT",
    "ICR_ARE01.ENERREA": "ICR_ARE01.ENERREA",
    "ICR_ARE01.ENERAPA": "ICR_ARE01.ENERAPA",
    "ICR_ARE01.ENERACT": "ICR_ARE01.ENERACT",
    PYR_2: "PYR_2",
    PYR_1: "PYR_1",
    PYR_GLOBAL_2: "PYR_GLOBAL_2",
    PYR_GLOBAL_1: "PYR_GLOBAL_1",
    PARTIAL_ODOMETER: "PARTIAL_ODOMETER",
    PK_NUMBER: "PK_NUMBER",
    ODOMETER: "ODOMETER",
    VEHICLE_STATUS_HUMANIZED: "VEHICLE_STATUS_HUMANIZED",
    SPEED: "SPEED",
    PK_ROAD: "PK_ROAD",
    NTS_VBAT: "NTS_VBAT",
    NTS_P3: "NTS_P3",
    NTS_N3: "NTS_N3",
    NTS_P2: "NTS_P2",
    NTS_N2: "NTS_N2",
    NTS_P1: "NTS_P1",
    NTS_N1: "NTS_N1",
    DPV: "DPV",
    PYR_GLOBAL_0: "PYR_GLOBAL_0",
    DEN_0: "DEN_0",
    ACTUADOR_3: "ACTUADOR_3",
    HR_2: "HR_2",
    TA_2: "TA_2",
    HR_1: "HR_1",
    TA_1: "TA_1",
    PLU_0: "PLU_0",
    DIR_0: "DIR_0",
    VEL_0: "VEL_0",
    LONG: "LONG",
    LAT: "LAT",
    STV_O_1: "STV_O_1",
    STV_J_1: "STV_J_1",
    STV_H_1: "STV_H_1",
    STV_F_1: "STV_F_1",
    CO2_0: "CO2_0",
    PYR_0: "PYR_0",
    STV_O: "STV_O",
    STV_Q: "STV_Q",
    STV_J: "STV_J",
    STV_H: "STV_H",
    STV_F: "STV_F",
    DWP_0: "DWP_0",
    HR_0: "HR_0",
    TA_0: "TA_0",
    BAT: "BAT",
} as const;
export type SensorNameEnum =
    (typeof SensorNameEnum)[keyof typeof SensorNameEnum];
export const SensorNameEnumSchema = z.enum(SensorNameEnum);
